/* eslint-disable max-len */
import { motion } from 'framer-motion';
import React,{useState,useContext,useCallback,useRef} from 'react'
import { Link } from 'react-router-dom';
import { CDN } from '../../constants';
import CategoryToolTip from '../CategoryToolTip';
import { ExpectedDateGenerator } from '../../redux/helper/DateConverter';
import OfferToolTip from '../OfferToolTip';
import ItemPriceTooltip from '../ItemPriceTooltip';
import HeaderContext from '../Context/HeaderContext';
import { CartPayload } from '../../redux/helper/CartPayloadGenerator';
import { distributorService } from '../../service/distributor.service';
import WishlistHandler from '../WishlistHandler';
import { Addtowishlist, WishlistExist } from '../../redux/helper/AddWishlist';
import ReactModal from 'react-modal';
import RemovePopup from '../../Pages/CartManagement/RemoveItem.jsx';
import AddressSelectionCard from './AddressSelectionCard';
import ProposedComponent from './ProposedComponent';
import './style.css';
import AddressChangeModal from './AddressChangeModal';

export default function CartItemCard({
    setdefaultAddress,
    defaultAddress,
    idx,
    prod,
    GetCartItems,
    wishProducts,
    ErrorID,
    setErrorID,
    cartCount,
    setcartCount,
    orderFlow,
    handleFlow,
    addressDropdown,
    selectedAddressObj,
    setselectedAddressObj,
    proposedCount,
    setproposedCount,
    isSpecialOffer,
    splitModal,
    setSplitModal,
    splitPopup,
    setSplitPopup
}) {
    const handleImage = (img)=> img?`${CDN}/product-images/${img}`:'/images/gen.png';
    const [hoverId, sethoverId] = useState('');
    const [OfferhoverId, setOfferhoverId] = useState('');
    const [ItemPricehoverId, setitemPricehoverId] = useState('');
    const [updatingValue, setupdatingValue] = useState(0);
    const [focusedInput, setfocusedInput] = useState('');
    const [removePopup, setremovePopup] = useState('')
    const [removeLoader, setremoveLoader] = useState(false)
    const [loading, setloading] = useState(false);
    const [ModalOpen, setModalOpen] = useState('');
    const profile = JSON.parse(localStorage.getItem('user'))?.profile
    const [loader, setloader] = useState(false);
    const [addresChangeModal, setaddresChangeModal] = useState('')
    const typingTimer = useRef(null);

    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);

    // Disable "-" once the quantity is at (or below) the minimum order quantity
    // i.e. one pack step down would fall below the MOQ (also covers MOQ smaller than pack size)
    const isAtMinQuantity = (Math.ceil(Number(cartCount[prod.item_id] ?? prod.quantity) / (Number(prod?.PACKING_SIZE) || 1) - 1e-6) - 1)
        * (Number(prod?.PACKING_SIZE) || 1) < (Number(prod?.MINIMUM_ORDER_QUANTITY) || Number(prod?.PACKING_SIZE) || 1) - 1e-6;
    const handleQuantityChange = (type,product)=>{
        // Use the latest local count so rapid clicks don't reuse a stale prod.quantity
        const current = Number(cartCount[product.item_id] ?? product.quantity);
        const pack = Number(product?.PACKING_SIZE) || 1;
        const moq = Number(product?.MINIMUM_ORDER_QUANTITY) || pack;
        // Work in whole pack steps to avoid floating point modulo errors (e.g. 1.05 % 0.01)
        const steps = current / pack;
        const nextSteps = type === '+' ? Math.floor(steps + 1e-6) + 1 : Math.ceil(steps - 1e-6) - 1;
        const next = Number((nextSteps * pack).toFixed(4));
        if (next <= 0 || next < moq) return;
        setcartCount({...cartCount, [product.item_id]: next});
        handleConfirm(next,product).then((success)=>{
            if(!success) setcartCount((prev)=>({...prev, [product.item_id]: current}));
        })
    }
    
    const handleErrorMessage = (message,key)=>{
        SetErrorMessage(message ||'Something went wrong');
        setcolorValue(true);
        setModalOpen('');
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
            setloading(false);
            setremoveLoader(false)
            setremovePopup('')

        }, 1000);
    }
    const handleSuccessMessage = (message,key)=>{
        SetSuccessMessage(message);
        setModalOpen('');
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            setloading(false);
            setremoveLoader(false)
            setremovePopup('')
            if(key==='diff'){
                setModalOpen('popup');
            }
        },1000)
    }
    const handleAddToWishList = (selected,related)=>{
        setloader(true)
        Addtowishlist(prod,selected).then((res)=>{
            if(res.data.success_status){
                handleSuccessMessage(res.data.message,'wish')
            }else{
                handleErrorMessage(res.message.response.data.message,'wish')
            }
            GetCartItems
            setloader(false)
        })
    }
    const handleConfirm = useCallback(
        async(quantity,product,propose)=>{
            setErrorID('')
            if(propose ===undefined && (Math.round(quantity * 10000) % Math.round((product?.PACKING_SIZE || 1) * 10000) !== 0)){
                setErrorID(product.item_id);
                setloading(false)
                return;
            }
            setloading(true)
            product.LIST_PRICE=Number(product.LIST_PRICE)
            const payload=CartPayload(product,quantity)
            if(propose){
                product.proposed_type = propose.type;
                product.proposed_total_price = propose.total_price;
                product.proposed_amount = propose.user_input;
            }
            let  res;
            if(propose){
                res = await distributorService.BulkAddProducts([product]);
            }else{
                res = await distributorService.AddToCart(payload);
            }
            if(!res.error && res.data.success_status){
                setloading(false)
                GetCartItems('key');
                setupdatingValue('')
                return true
            }else{
                setloading(false)
                return false
            }
        },
        [updatingValue],
    )
    const handleError = ()=>{
        let status=false;
        if(Number(cartCount[prod.item_id]) < Number(prod.MINIMUM_ORDER_QUANTITY)){
            status=true
        }
        if(Math.round((cartCount[prod.item_id]) * 10000) % Math.round((prod.PACKING_SIZE ||1) * 10000) !==0){
            status=true
        }
        if(ErrorID!==''){
            status=true

        }
        return status
    }
    const RemoveFromCart=async(id)=>{
        const remove = await distributorService.RemoveFromCart(removePopup);
        if(!remove.error &&remove.data.success_status){
            handleSuccessMessage(remove?.data?.message);
        }else{
            handleErrorMessage(remove?.message?.response?.data?.message,'')
        }
        GetCartItems()
    }
    const handleDiscount =(prod)=>{
        let discountValue=prod?.discount_applied
        if(prod?.discount_type==="₹"){
            discountValue = Number(prod?.discount_applied).toLocaleString('en-IN', {
                style: 'currency',
                currency: 'INR',
            })
        }else{
            discountValue= Number(prod.trade_discount)+ Number(prod.additinal_discount)
        }
        return discountValue}

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };
    return (
        <div className={`rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-1.5 pt-4 relative ${idx===0?'':'mt-5'}`} style={{ zIndex: 100 - idx }}>
            <div className="flex flex-wrap">
                <ReactModal style={{customStyles}} isOpen={removePopup!==''}>
                    <RemovePopup
                        RemoveFromCart={RemoveFromCart}
                        setremovePopup={setremovePopup}
                        loading={removeLoader}
                        setremoveLoader={setremoveLoader}/>
                </ReactModal>
                <div className="xl:w-[75%] w-full pt-2">
                    <div className="flex">
                        <div className="w-1/4">
                            <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}>
                                <motion.img initial={{ opacity: 0, scale: 0.6 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    transition={{
                                        duration: 0.8,
                                        delay: 0.5,
                                        ease: [0, 0.71, 0.2, 1.01]
                                    }} src={handleImage(prod?.IMAGE_NAME)} alt="icon" className="w-full" />
                            </Link>                        </div>
                        <div className="pl-2.5">
                            <div>
                                <Link to={`/products/${prod.INVENTORY_ITEM_ID}/view`}><p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION || `${prod?.DESCRIPTION.length > 20 ? `${prod.DESCRIPTION.slice(0,20)}...`:`${prod.DESCRIPTION}`}`}<span className="text-xs font-semibold text-[#FFFFFF] bg-[#44445e] rounded px-1.5 py-1 w-fit ml-2.5 ml-2.5">{prod?.MAIN_CATEGORY}</span></p></Link>
                            </div>
                            <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1"><span>Product Code: {prod?.CONCATENATED_SEGMENTS}</span><span className="sm:px-4 px-2">|</span><span>AWS Classification: {prod?.AWS_CLASSIFICATION}</span></p>
                            <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                    <p className="text-xs font-semibold text-[090406]">Category</p>
                                    <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">{prod?.DELIVERY_LEAD_TIME}</p>
                                    <button  >
                                        <img src="images/info_icon.svg" alt="icon" className="cursor-pointer w-[10px]" onMouseEnter={()=>{
                                            setTimeout(() => {
                                                sethoverId(prod.INVENTORY_ITEM_ID)
                                            }, 1000);
                                        }} onMouseLeave={()=>{
                                            setTimeout(() => {
                                                sethoverId('')
                                            }, 2000);
                                        }}/>
                                    </button>
                                    {hoverId=== prod.INVENTORY_ITEM_ID &&(
                                        <CategoryToolTip hover={hoverId=== prod.INVENTORY_ITEM_ID}/>
                                    )}
                                </div>
                                <p className="text-xs font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">Expected Dispatch: <span className="font-bold text-[#555259]">{prod.DELIVERY_LEAD_TIME ? ExpectedDateGenerator(prod?.DELIVERY_LEAD_TIME):'-'}</span></p>
                                <p className="text-xs font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">Method of Packing: <span className="font-bold text-[#555259]">{prod?.METHOD_OF_PACKING}</span></p>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-[70%] w-full sm:pl-4">
                        <p className="sm:text-base text-xs6 font-normal text-[#808285] sm:pt-1 pt-2">{prod?.DESCRIPTION}</p>

                    </div>
                </div>
                <div className="xl:w-[25%] w-full pt-0 xl:mt-0 mt-3">
                    <div className="flex justify-end w-full xl:pr-[72px] pr-0">
                        <p className={`sm:text-xs6 text-xs2 font-normal text-[#808285] bg-[#F5F5FA] rounded-[3px] px-2.5 py-[7px] w-fit  xl:mb-0 mb-3 ${profile?.PRIVILAGES.includes('stock_visibility')?'':'opacity-0'}`}>Stock: {prod?.STOCK_VISIBILITY ? <span className="text-[#424446] font-semibold">{prod?.STOCK_ONHAND_QTY} <>{prod?.PRIMARY_UOM_CODE}</></span>:0}</p>
                        {!(orderFlow?.selectAddressClicked) && prod?.split_address === true && (prod?.offer_type === 'Special' || prod?.offer_type === 'Special Recurring') && prod?.deal !== '' && 
                            <button 
                                type="button" 
                                className="ml-[10px] flex items-center bg-[#F5F5FA] font-bold text-xs text-[#555259] border-2 border-[#E9EDF4] px-2 rounded-[9px]" 
                                data-bs-toggle="modal" 
                                data-bs-target="#filtermodal"
                                onClick={()=> { setSplitModal(prod); setSplitPopup(!splitPopup)}}
                            >
                                <img src="/images/split-product.svg" className='pl-[5px]'></img> <p className="ml-2 sm:text-xs6 text-xs2 font-normal text-[#808285] bg-[#F5F5FA] rounded-[3px] w-fit">Split Product</p>
                            </button>
                        }
                    </div>
                    
                </div>
            </div>
            <div className= {`${orderFlow.selectAddressClicked?'w-full lg:px-2 mt-2.5 mb-3.5':'lg:w-[80%] w-full lg:px-4 pt-2.5 pb-3.5'}`}>
                {orderFlow.selectAddressClicked ? <ProposedComponent 
                    prod={prod}
                    orderFlow={orderFlow}
                    selectedAddressObj={selectedAddressObj}
                    setselectedAddressObj={setselectedAddressObj}
                    proposedCount={proposedCount}
                    setproposedCount={setproposedCount}
                    handleConfirm={handleConfirm}
                    setaddresChangeModal={setaddresChangeModal}
                />:<div className="flex sm:flex-row flex-col">
                    <div className="flex items-center sm:w-[50%] w-full">
                        <div className="w-[50%]">
                            <p className="text-xs font-semibold text-[#808285]">Unit of Measurement</p>
                            <p className="text-xs6 font-semibold text-[#555259]">{prod?.PRIMARY_UOM_CODE}</p>
                        </div>
                        <div className="w-1/2">
                            <p className="text-xs font-semibold text-[#808285]">Minimum Order Quantity</p>
                            <p className="text-xs6 font-semibold text-[#555259]">{prod?.MINIMUM_ORDER_QUANTITY || 1}<>{prod?.PRIMARY_UOM_CODE}</></p>
                        </div>
                    </div>
                    <div className="flex items-center sm:w-[50%] w-full sm:mt-0 mt-3">
                        <div className="w-1/2">
                            <p className="text-xs font-semibold text-[#808285]">Standard Pack Size</p>
                            <p className="text-xs6 font-semibold text-[#555259]">{prod?.PACKING_SIZE||1} {prod?.PRIMARY_UOM_CODE}</p>
                        </div>
                        <div className="w-1/2">
                            <p className="text-xs font-semibold text-[#808285]">Size</p>
                            <p className="text-xs6 font-semibold text-[#555259]">
                                <>
                                    <>{`${prod.DIAMETER!==null ?`${prod.DIAMETER}mm`:''}`}</>
                                    <>{`${prod.LENGTH!==null && prod.DIAMETER ? 'x':''}`}</>
                                    <>{`${prod.LENGTH!==null ?`${prod.LENGTH}mm`:''}`}</>
                                    <>{prod.LENGTH===null && prod.DIAMETER===null ? '-':''}</>
                                </>
                            </p>
                        </div>
                    </div>
                </div>
                }
            </div>
            {orderFlow.order_type==='' &&(
                <div className="pt-2 border-t border-[#CBCBCB] w-full flex items-center flex-wrap lg:px-4 px-0">
                    <div className="flex items-center xl:justify-start xl:w-[44%] w-full justify-between">
                        <div className="2xl:w-[38%] xl:w-[50%] w-full">
                            <p className="text-xs3 font-semibold text-[#808285]">List Price</p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                {Number(prod?.LIST_PRICE)?.toLocaleString('en-IN', {
                                    style: 'currency',
                                    currency: 'INR',
                                })}</p>
                        </div>
                        { isSpecialOffer === false ? 
                            <div className="ml-4 2xl:w-[50%]">
                                <p className="text-xs3 font-semibold text-[#808285] text-center">Set Quantity</p>
                                <div className={`flex items-stretch mx-auto mt-2 w-fit h-[36px] rounded-md border bg-white overflow-hidden transition-colors ${ErrorID === prod.item_id ? 'border-[#ED1C24]' : 'border-[#CBCBCB] focus-within:border-[#555259]'}`}>
                                    <button
                                        onClick={()=>handleQuantityChange('-',prod)}
                                        disabled={loading || isSpecialOffer === true || isAtMinQuantity}
                                        aria-label="Decrease quantity"
                                        title={isAtMinQuantity ? 'Quantity is at the minimum order quantity' : 'Decrease quantity'}
                                        type="button" className="w-[36px] flex items-center justify-center bg-[#E4E4EA] text-[#555259] border-r border-[#CBCBCB] hover:bg-[#555259] hover:text-white active:bg-[#3d3b40] active:text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-[#E4E4EA] disabled:hover:text-[#555259]">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                    </button>
                                    <div className="flex items-center px-2 gap-1">
                                        <input type="text" inputMode="decimal" aria-label="Quantity"
                                            onFocus={()=>{
                                                setupdatingValue(prod.quantity);
                                                setfocusedInput(prod?.item_id)
                                            }}
                                            onChange={(e)=>{
                                                const value = e.target.value;
                                                if(!/^\d*\.?\d{0,4}$/.test(value)) return;
                                                setcartCount({...cartCount, [prod.item_id]: value})
                                                // Wait until the user stops typing; updating on every key press
                                                // sent "9." as 9 and the cart refresh wiped the decimal part
                                                clearTimeout(typingTimer.current);
                                                if(value === '' || value.endsWith('.')) return;
                                                typingTimer.current = setTimeout(()=>{
                                                    if(Number(value) > 0){
                                                        handleConfirm(value,prod)}
                                                    else{
                                                        setErrorID(prod.item_id)
                                                    }
                                                }, 800);
                                            }}
                                            onKeyDown={(e) => ['ArrowUp','ArrowDown'].includes(e.key) && e.preventDefault()}
                                            value={cartCount[prod.item_id]}
                                            disabled={isSpecialOffer === true}
                                            className="w-[80px] h-full border-0 outline-none focus:outline-none focus:ring-0 shadow-none bg-transparent text-center sm:text-[15px] text-sm font-semibold text-[#090406]" />
                                        <span className="text-sm font-semibold text-[#808285]">{prod?.PRIMARY_UOM_CODE}</span>
                                    </div>
                                    <button
                                        onClick={()=>handleQuantityChange('+',prod)}
                                        disabled={loading}
                                        aria-label="Increase quantity"
                                        title="Increase quantity"
                                        type="button" className="w-[36px] flex items-center justify-center bg-[#E4E4EA] text-[#555259] border-l border-[#CBCBCB] hover:bg-[#555259] hover:text-white active:bg-[#3d3b40] active:text-white transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-[#E4E4EA] disabled:hover:text-[#555259]">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 6h8M6 2v8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
                                    </button>
                                </div>
                            </div>: 
                            <div className="ml-4 2xl:w-[50%]">
                                <p className="text-xs3 font-semibold text-[#808285]">Quantity</p>
                                <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                    {Number(prod?.quantity)} {prod?.PRIMARY_UOM_CODE}</p>
                            </div>
                        }
                    </div>
                    <div className='xl:w-[56%] w-full xl:mt-0 mt-4 flex justify-between xl:pl-6'>
                        <div>
                            <p className="text-xs3 font-semibold text-[#808285]">Sub Total</p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                {Number(prod?.sub_total)?.toLocaleString('en-IN', {
                                    style: 'currency',
                                    currency: 'INR',
                                })}</p>
                        </div>
                        <div className="pl-1">
                            <p className="text-xs3 font-semibold text-[#808285]">Discount</p>
                            <p className="text-lg font-semibold text-[#15090E] flex items-center pt-0.5">
                                <>{
                                    Number(prod?.discount_applied||0).toLocaleString('en-IN', {
                                        style: 'currency',
                                        currency: 'INR',
                                    })}
                                </>
                                <span className="ml-1" style={{minWidth:'30px'}}>
                                    <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                        setTimeout(() => {
                                            setOfferhoverId(prod.INVENTORY_ITEM_ID)
                                        }, 100);
                                    }} onMouseLeave={()=>{
                                        setTimeout(() => {
                                            setOfferhoverId('')
                                        }, 2000);
                                    }}>
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer" />
                                    </button>
                                    <>
                                        {
                                            OfferhoverId=== prod.INVENTORY_ITEM_ID &&(
                                                <OfferToolTip hover={OfferhoverId=== prod.INVENTORY_ITEM_ID} prod={prod}/>
                                            )}
                                    </>
                                    <OfferToolTip prod={prod} />
                                </span>
                            </p>
                            
                        </div>
                        <div className="pl-1">
                            <p className="text-xs3 font-semibold text-[#808285]">DAP</p>
                            <p className="md:text-xs10 sm:text-lg text-base font-semibold text-[#15090E]">
                                {Number(prod?.dap)?.toLocaleString('en-IN', {
                                    style: 'currency',
                                    currency: 'INR',
                                })}</p>
                        </div>
                    </div>
                    <div className="flex items-center justify-between w-full mt-4 ">
                        
                        <div className="xl:min-w-[268px] w-full bg-[#F5F5FA] rounded-lg text-center flex flex-col justify-center items-center py-1.5">
                            <p className="text-xs2 font-semibold text-[#808285]">Total Price</p>
                            <div className="flex items-center sm:pt-0.5 relative">
                                <p className="md:text-xs4 text-base font-semibold text-[#15090E] mr-2">
                                    {Number(prod?.total_price||0)?.toLocaleString('en-IN', {
                                        style: 'currency',
                                        currency: 'INR',
                                    })}</p>
                                <span>
                                    <button data-tooltip-target="tooltip-discountPercentage" data-tooltip-placement="right" data-tooltip-trigger="click" type="button" onMouseEnter={()=>{
                                        setTimeout(() => {
                                            setitemPricehoverId(prod.INVENTORY_ITEM_ID)
                                        }, 100);
                                    }} onMouseLeave={()=>{
                                        setitemPricehoverId('')
                                    }}>
                                        <img src="/images/info-filled_icon.svg" alt="icon" className="cursor-pointer w-[14px] h-[14px]" />
                                    </button>
                                    <>
                                        {
                                            ItemPricehoverId=== prod.INVENTORY_ITEM_ID &&(
                                                (() => {
                                                    const subTotal = Number(prod?.sub_total) || 0;
                                                    const totalPrice = Number(prod?.total_price) || 0;
                                                    const dap = Number(prod?.dap) || 0;
                                                    // Subtract DAP from totalPrice for net discount calculation
                                                    const netDiscount = subTotal > 0 ? ((subTotal - totalPrice + dap) / subTotal) * 100 : 0;
                                                    return (
                                                        <ItemPriceTooltip 
                                                            hover={ItemPricehoverId === prod.INVENTORY_ITEM_ID} 
                                                            prod={prod} 
                                                            itemPriceValue={totalPrice/prod?.quantity}
                                                            netDiscount={netDiscount}
                                                            onMouseEnter={()=>{
                                                                setitemPricehoverId(prod.INVENTORY_ITEM_ID)
                                                            }}
                                                            onMouseLeave={()=>{
                                                                setitemPricehoverId('')
                                                            }}
                                                        />
                                                    );
                                                })()
                                            )}
                                    </>
                                    {(() => {
                                        const subTotal = Number(prod?.sub_total) || 0;
                                        const totalPrice = Number(prod?.total_price) || 0;
                                        const dap = Number(prod?.dap) || 0;
                                        // Subtract DAP from totalPrice for net discount calculation
                                        const netDiscount = subTotal > 0 ? ((subTotal - totalPrice + dap) / subTotal) * 100 : 0;
                                        return (
                                            <ItemPriceTooltip 
                                                prod={prod} 
                                                itemPriceValue={totalPrice/prod?.quantity}
                                                netDiscount={netDiscount}
                                            />
                                        );
                                    })()}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>)}
            <>{orderFlow.order_type!=='' && !orderFlow.selectAddressClicked  &&(
                <AddressSelectionCard 
                    prod={prod}
                    idx={idx}
                    addressDropdown={addressDropdown}
                    setdefaultAddress={setdefaultAddress}
                    defaultAddress={defaultAddress}
                    cartCount={cartCount}
                    handleDiscount={handleDiscount}
                    selectedAddressObj={selectedAddressObj}
                    setselectedAddressObj={setselectedAddressObj} />
            )}</>
            {ModalOpen !=='' && <WishlistHandler 
                setmodalType={setModalOpen}
                selectedItem={prod}
                handleAddToWishList={handleAddToWishList}
                wishlistLoader={loader}
                wishlistProduct={wishProducts}
                handleErrorMessage={handleErrorMessage}
                handleSuccessMessage={handleSuccessMessage}
                FromCart={true}
            />}
            <div style={{visibility:`${orderFlow.order_type ===''?'visible':'hidden'},`,display:`${(orderFlow.order_type==='Trade Order'&& orderFlow.selectAddressClicked) ? 'none':''}`}}>
                <p className={`lg:px-4 mt-2 text-xs3 font-normal ${ handleError()?'text-[red]':'text-[#808285]'} flex items-center`}>
                    <span className="mr-1">
                        <img src="images/info_icon1.svg" alt="icon" className="min-w-[9px] min-h-[9px]"/>
                    </span>
                    Quantity is based on the MOQ and Standard Pack Size 
                </p>
                <>{orderFlow.order_type==='' &&
                <>
                    <button type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2">
                        <img src={ WishlistExist(wishProducts,prod.INVENTORY_ITEM_ID)?'/images/heart_active.svg':'/images/Iconawesome-heart.svg'} alt="" 
                            onClick={()=>{
                                setModalOpen('popup');
                            }} className="absolute sm:top-6 top-[17px] sm:right-[60px] right-[50px] cursor-pointer"/>
                    </button>
                    {isSpecialOffer === false && <button 
                        onClick={()=>setremovePopup(prod.item_id)}
                        type="button" data-bs-toggle="modal" data-bs-target="#removefromWishes">
                        <img src="images/Icon-feather-trash-2.svg" alt="icon" className="absolute sm:top-6 top-[17px] right-[22px] cursor-pointer"/>
                    </button>}
                </>
                }</>
            </div>
            <ReactModal isOpen={addresChangeModal !==''}>
                <AddressChangeModal
                    addresChangeModal={addresChangeModal}
                    prod={prod}
                    selectedAddressObj={selectedAddressObj}
                    setselectedAddressObj={setselectedAddressObj}
                    addressDropdown={addressDropdown}
                />
            </ReactModal>

        </div>
    )
}
